import { Outlet } from 'react-router-dom';

import AppProviders from 'state/providers/AppProviders';
import AppLoadListeners from './AppLoadListeners';

const AuthenticatedApp: React.FC = () => (
  <AppProviders>
    <AppLoadListeners>
      <Outlet />
    </AppLoadListeners>
  </AppProviders>
);

export default AuthenticatedApp;
